import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { LinkBox } from '@hero/components/molecules';
import { useNotification } from '@hero/store/hooks';

import { ShareLinkDropdown } from '../ShareLinkDropdown';

import * as S from './style';

function ShareLink({
  position,
  secureSingleLink,
  isShareable = true,
  isJustCopyable = false,
  name,
  shareButtonVariant
}) {
  const { t } = useTranslation();

  const { showSuccess } = useNotification();

  function handleCopy() {
    navigator.clipboard.writeText(secureSingleLink);
    showSuccess({
      message: t('uniqueGiftLinkSuccessfullyCopied'),
      type: 'toast'
    });
  }

  const isShareableState = isShareable && !name;

  return (
    <S.ShareLink>
      <LinkBox
        link={name ? t('hasAlreadyRedeemedBy', { name }) : secureSingleLink}
        {...((isShareableState || isJustCopyable) && { onCopy: handleCopy })}
        active={!name}
      />
      {isShareableState && (
        <ShareLinkDropdown
          placement={position}
          link={secureSingleLink}
          onCopy={handleCopy}
          shareButtonVariant={shareButtonVariant}
        />
      )}
    </S.ShareLink>
  );
}

ShareLink.S = S;

ShareLink.propTypes = {
  position: PropTypes.string,
  secureSingleLink: PropTypes.string,
  name: PropTypes.string
};

export { ShareLink };
